export default function assetHasError(asset) {
  if (!asset || !asset.assetFiles) {return false;}

  const { assetFiles: { ORIGINAL } } = asset;

  return ORIGINAL && ORIGINAL.status === 'ERROR';
}